module.exports = __webpack_public_path__ + "img/like.77c703e9.svg";